import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import AIMS_FLAVORS from 'lib/aimsFlavors';
import { content as ContentPropType } from 'lib/CustomPropTypes';

import { FeaturedEmbed } from 'components/packages/CoverSpread/Featured/Embed';
import { FeaturedPlaymaker } from 'components/packages/CoverSpread/Featured/Playmaker';
import { FeaturedVideo } from 'components/packages/CoverSpread/Featured/Video';
import { Tease } from 'components/packages/CoverSpread/Tease';
import { isTeasePlaymakerOverride } from 'components/packages/CoverSpread/utility';

const block = 'cover-spread-featured';

const FEATURED_ITEM_INDEX = 0;

function Featured(props) {
  const {
    content,
    content: {
      type,
      metadata: itemMetadata,
    },
    isRailAdjacent,
    packageMetadata,
  } = props;

  let FeatureComponent = Tease;

  // Embed, e.g., dataviz
  if (type === 'custom' && get(itemMetadata, 'useEmbed', false)) {
    FeatureComponent = FeaturedEmbed;
  // Playmaker video
  } else if (isTeasePlaymakerOverride(FEATURED_ITEM_INDEX, 'feature', itemMetadata)) {
    FeatureComponent = FeaturedPlaymaker;
  // Standard video
  } else if (type === 'video') {
    FeatureComponent = FeaturedVideo;
  }

  return (
    <div
      className={block}
      data-test={block}
    >
      <FeatureComponent
        block={block}
        content={content}
        headlineSizes="f6 f7-m"
        isRailAdjacent={isRailAdjacent}
        packageMetadata={packageMetadata}
        responsiveFlavors={{
          s: AIMS_FLAVORS.FOCAL_380x190,
          m: AIMS_FLAVORS.FOCAL_520x260,
          l: AIMS_FLAVORS.FOCAL_600x300,
          xl: AIMS_FLAVORS.FOCAL_560x280,
        }}
      />
    </div>
  );
}

Featured.propTypes = {
  content: ContentPropType.isRequired,
  isRailAdjacent: PropTypes.bool,
  packageMetadata: PropTypes.shape({}),
};

Featured.defaultProps = {
  isRailAdjacent: false,
  packageMetadata: {},
};

export { Featured };
